import { Link } from "react-router-dom";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { useMyStore } from "@/pages/dashboard/hooks/useMyStore";
import { PageHeader } from "@/components/PageHeader";
import AnalyticsFunnel from "./components/AnalyticsFunnel";
import TopProductsTable from "./components/TopProductsTable";
import { useStoreAnalytics } from "./hooks/useStoreAnalytics";

export default function AnalyticsPage() {
  const { store, loading: storeLoading } = useMyStore();
  const { data, loading: analyticsLoading, error } = useStoreAnalytics();

  const loading = storeLoading || analyticsLoading;

  if (loading) {
    return (
      <div className="container-elegant page-padding space-y-8">
        <Skeleton className="h-10 w-48" />
        <Skeleton className="h-6 w-40" />
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-64 w-full" />
      </div>
    );
  }

  if (!store) {
    return (
      <div className="container-elegant page-padding">
        <PageHeader title="Análises" />
        <section className="max-w-xl border border-primary-200 dark:border-primary-800 panel-padding">
          <h2 className="text-xl font-light text-primary-900 dark:text-white mb-3">
            Crie sua loja primeiro
          </h2>
          <p className="text-sm font-light text-primary-600 dark:text-primary-400 mb-6">
            Você precisa configurar uma loja antes de visualizar análises.
          </p>
          <Button asChild>
            <Link to="/store/settings">CONFIGURAR LOJA</Link>
          </Button>
        </section>
      </div>
    );
  }

  return (
    <div className="container-elegant page-padding">
      <PageHeader
        title="Análises"
        description={`Últimos ${store.analyticsWindowDays} dias`}
      />

      {error && (
        <Alert variant="destructive" className="mb-8">
          <AlertTitle>Erro</AlertTitle>
          <AlertDescription>
            {error.message || "Não foi possível carregar as análises."}
          </AlertDescription>
        </Alert>
      )}

      {data && (
        <div className="space-y-12">
          <AnalyticsFunnel
            storeViews={data.storeViews}
            productViews={data.productViews}
            whatsappClicks={data.whatsappClicks}
          />
          <TopProductsTable
            topViewedProducts={data.topViewedProducts}
            topClickedProducts={data.topClickedProducts}
          />
        </div>
      )}
    </div>
  );
}
